import Navbar from "./Navbar";
import HomeSlider from "./Chapters/Home_Slider";
import ActivityDetails from "./Chapters/Activities_Details";
import LatestStories from "./Chapters/Latest_stories";
import Footer from "./Footer";
import './Css/Chapters.css';

function Chapters() {
  return (
    <div>
      <Navbar />
      {/* <HomeSlider /> */}
      <ActivityDetails />
      <LatestStories />
      <Footer />
    </div>
  );
}

export default Chapters;